"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkbox = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var checkbox_style_1 = require("./checkbox-style");
function Checkbox(props) {
    return (0, jsx_runtime_1.jsx)(checkbox_style_1.StyledCheckbox, __assign({}, props));
}
exports.Checkbox = Checkbox;
